import OfficeImg from "../knudsenOffice.png"

export default function Office() {

    return (
        <div className="Office">
            <img src={OfficeImg} alt="Knudsen Office"></img>
        </div>
    )
}
